import React from 'react';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import AppDiscovery from '@atlassian/jira-servicedesk-app-discovery/src/ui/index.tsx';
import { toBaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';

export const AppDiscoverySettings = () => {
	const baseUrl = toBaseUrl('');
	const { data: projectContext } = useProjectContext();

	if (projectContext == null) {
		return null;
	}

	return (
		<AppDiscovery
			baseUrl={baseUrl}
			projectKey={projectContext.projectKey}
			isJiraAdmin={projectContext.isProjectAdmin || false}
			isProjectSimplified={projectContext.simplified}
			projectName={projectContext.projectName}
		/>
	);
};
